var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLanguage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83301 7.48341H9.58301M9.58301 7.48341H12.083M9.58301 7.48341V6.33398M14.1663 7.48341H12.083M12.083 7.48341C11.6434 9.05532 10.7229 10.5412 9.67226 11.8472M9.67226 11.8472C8.80226 12.9285 7.84305 13.8863 6.99372 14.6673M9.67226 11.8472C9.13659 11.2191 8.38659 10.2028 8.17229 9.74307M9.67226 11.8472L11.2794 13.5179",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.08301 10.5007C2.08301 6.7687 2.08301 4.90273 3.24237 3.74335C4.40175 2.58398 6.26772 2.58398 9.99967 2.58398C13.7316 2.58398 15.5976 2.58398 16.757 3.74335C17.9163 4.90273 17.9163 6.7687 17.9163 10.5007C17.9163 14.2326 17.9163 16.0986 16.757 17.258C15.5976 18.4173 13.7316 18.4173 9.99967 18.4173C6.26772 18.4173 4.40175 18.4173 3.24237 17.258C2.08301 16.0986 2.08301 14.2326 2.08301 10.5007Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.9d763f3a49f2c4ed0d2f1454d9d7fe7d.svg";
export { ForwardRef as ReactComponent };